export type UspTrade = "HVAC" | "Electrical" | "Plumbing" | "Roofing";

export interface UspTradeFiles {
  /** "Name Branding Agreement" (2025 · PDF). */
  branding: string | null;
  /** "USP SFPG" (PDF). */
  usp: string | null;
}

/**
 * Licensing PDFs for each trade's agreement card.
 *
 * TODO: marketing owes permanent links. The designed page pointed at
 * presigned S3 URLs that expired an hour after they were generated, so they
 * were not carried over. Each download link on the page renders only once
 * its URL here is non-null.
 */
export const USP_LICENSING_FILE_URLS: Record<UspTrade, UspTradeFiles> = {
  HVAC: { branding: null, usp: null },
  Electrical: { branding: null, usp: null },
  Plumbing: { branding: null, usp: null },
  Roofing: { branding: null, usp: null },
};
